import { Link, useLocation } from "react-router-dom";
import { Mui } from "@osu/react-ui";
import { mergeSxStyles } from "../../styles/util";
import { APPLICATION_NAME } from "../../util/constants";
import { navLinkStyles } from "../../styles/commonSx";

const linkStyles = navLinkStyles

const InternalLink = ({ to, children, disableHighlightCurrent, sx, ...rest }) => {
  const { pathname } = useLocation()
  const isSame = pathname === to
  const styles = mergeSxStyles(linkStyles({ isSame, disableHighlightCurrent }), sx)
  const props = {
    component: Link,
    to
  }
  if(isSame) {
    props["aria-current"] = "page"
  }
  return (
    <Mui.Button
      sx={styles}
      {...props}
      {...rest}
    >
      {children}
    </Mui.Button>
  );
};

export const AppLink = (props = {}) => <InternalLink to="/" disableHighlightCurrent {...props}>
  {APPLICATION_NAME}
</InternalLink>

export default InternalLink;
